import React from 'react';
import { isNull } from 'lodash';

import Modal from '../../../../../../components/Modal/Modal';
import BaseForm from '../../../../../../components/form/BaseForm/BaseForm';
import { setDash, setNumberWithComma, setPhoneFormat } from '../../../../../../lib/common';
import SelectForm from '../../../../../../components/form/SelectForm';
import {
  MAXIMUM_NUMBER_OF_AMOUNT,
  MINIMUM_NUMBER_OF_AMOUNT,
  POINT_LOG_TYPE,
  POINT_LOG_TYPE_SELECT_LIST,
} from '../../../../../../constants/service/app/pointConstants';
import { formRequiredRules } from '../../../../../../lib/formRules';
import { REQUIRED_MSG } from '../../../../../../constants/service/common/formRulesConstants';
import InputForm from '../../../../../../components/form/InputForm';
import { REX_NUMBER } from '../../../../../../lib/rex';
import './GeneratePointUserDetailModal.scss';

const GeneratePointUserDetailModalView = (props) => {
  const {
    form,
    isOpen = true,
    userPersonalInfo,
    pointCauseSelectList,
    onSubmit,
    closeModal,
    pointUserDetail,
    setPointCauseId,
    setType,
    setAmount,
    initCause,
  } = props;
  const { userId, name, cellPhone, pointAmount, usedPointAmount } = userPersonalInfo;

  return (
    <Modal
      title="포인트 발급"
      isOpen={isOpen}
      width={700}
      height={600}
      isFooter={true}
      okText="발급하기"
      onOk={() => onSubmit(pointUserDetail)}
      onClose={() => closeModal()}
    >
      <div className="point-generate-modal">
        <BaseForm label="회원 번호" content={userId} />
        <BaseForm label="이름" content={setDash(name)} />
        <BaseForm label="전화번호" content={setPhoneFormat(cellPhone)} />

        <BaseForm
          label="내역종류"
          content={
            <SelectForm
              className="select-search-option"
              form={form}
              name="type"
              list={POINT_LOG_TYPE_SELECT_LIST}
              placeholder={'선택'}
              rules={[
                formRequiredRules(true, REQUIRED_MSG, false),
                {
                  validator: (rule, value, cb) => {
                    if (value < POINT_LOG_TYPE.SAVE || value > POINT_LOG_TYPE.USE) {
                      cb('필수 값입니다.');
                      return;
                    }
                    cb();
                  },
                },
              ]}
              onChange={(value) => {
                setType(value);
                initCause();
              }}
            />
          }
        />

        <BaseForm
          label="적립/사용처"
          content={
            <SelectForm
              className="select-search-option"
              form={form}
              name="pointCauseId"
              list={
                pointUserDetail.type === POINT_LOG_TYPE.SAVE
                  ? pointCauseSelectList.filter((item) => item.type === POINT_LOG_TYPE.SAVE)
                  : pointCauseSelectList.filter((item) => item.type === POINT_LOG_TYPE.USE)
              }
              placeholder={'선택'}
              disabled={isNull(pointUserDetail.type)}
              rules={[
                formRequiredRules(true, REQUIRED_MSG, false),
                {
                  validator: (rule, value, cb) => {
                    if (isNull(value)) {
                      cb('필수 값입니다.');
                      return;
                    }
                    cb();
                  },
                },
              ]}
              onChange={(value) => setPointCauseId(value)}
            />
          }
        />

        <BaseForm
          label="액수"
          content={
            <InputForm
              form={form}
              name="amount"
              type="number"
              min={MINIMUM_NUMBER_OF_AMOUNT}
              max={MAXIMUM_NUMBER_OF_AMOUNT}
              placeholder={'0'}
              rules={[
                { pattern: REX_NUMBER, message: '필수 사항 입니다.' },
                {
                  validator: (rule, value, cb) => {
                    if (!value) {
                      cb('액수는 1원 이상입니다.');
                      return;
                    }
                    cb();
                  },
                },
              ]}
              onChange={(value) => setAmount(value)}
            />
          }
        />

        <BaseForm label="사용 가능한 포인트" content={setNumberWithComma(pointAmount)} />

        <BaseForm label="사용한 포인트" content={setNumberWithComma(usedPointAmount)} />
      </div>
    </Modal>
  );
};

export default GeneratePointUserDetailModalView;
